// @ts-nocheck

import { fetchRequest, initialFetchListParams } from '.';
/**
 * Получение списка СТОУ
 */
export const fetchStouList = async (params = initialFetchListParams) => await fetchRequest.get('/stou', {
  ...initialFetchListParams,
  ...params
});

/**
 * Обновление СТОУ записи
 */
export const updateStou = async stou => {
  const updated = await fetchRequest.put('/stou', stou);
  if (updated) return updated;
  throw new Error('Не удалось обновить СТОУ запись');
};

/**
 * Добавление СТОУ записи
 */
export const addStou = async stou => {
  const added = await fetchRequest.post('/stou', stou);
  if (added) return added;
  throw new Error('Не удалось добавить СТОУ запись');
};

// Удалить навесное оборудование по id
export const deleteStou = async id => await fetchRequest.delete(`/stou/${id}`);

/**
 * Получение СТОУ записи
 */
export const fetchStou = async (id, params = {}) => {
  const stou = await fetchRequest.get(`/stou/${id}`, params);
  if (stou) return stou;
  throw new Error('Не удалось получить СТОУ запись');
};
export default {
  fetchStouList,
  updateStou,
  fetchStou,
  addStou,
  deleteStou
};
